import type {
  DataTableExpandedRows,
  DataTableFilterMeta,
  DataTableFilterMetaData,
} from "primevue/datatable";

/**
 * Narrows one entry of a DataTable's `filters` model to a single-constraint filter, the shape every
 * table here binds. The model's type also allows operator filters (`filterDisplay="menu"` with
 * several constraints) and plain strings.
 */
export const isFilterMetaData = (
  entry: DataTableFilterMeta[string] | undefined
): entry is DataTableFilterMetaData =>
  typeof entry === "object" && "matchMode" in entry;

/**
 * A DataTable's `update:expandedRows` value, for a table with a `dataKey`: such a table keys its
 * expanded rows by that key, and only one without a `dataKey` reports them as a row array.
 *
 * @throws {Error} When the table reported a row array, i.e. it has no `dataKey`.
 */
export const expandedRowsByKey = (
  value: unknown[] | DataTableExpandedRows
): DataTableExpandedRows => {
  if (Array.isArray(value)) {
    throw new Error(
      "DataTable reported expanded rows as an array; give it a dataKey"
    );
  }
  return value;
};
